import { Flex } from 'antd'
import React, { useState } from 'react'
import { useRecoilState } from 'recoil'
import AopsSimpleHeader from '../../components/apos/AopsSimpleHeader'
import SectionHeader from '../../components/apos/SectionHeader'
import AopsVacationDetailModal from '../../components/apos/vacation/AopsVacationDetailModal'
import { userState } from '../../store/user'
import VacationEmployeesListTable from './VacationEmployeesListTable'
import './vacationPage.scss'
import VacationRequestListTable from './VacationRequestListTable '
import VacationSettlementTable from './VacationSettlementTable'
const VacationAdminPage = () => {
  const [user] = useRecoilState(userState)
  const [openDetailModal, setOpenDetailModal] = useState(false)
  const [selectedHistoryId, setSelectedHistoryId] = useState(null)
  const [selectedName, setSelectedName] = useState('')
  const [shouldRefresh, setShouldRefresh] = useState(false)

  return (
    <div className="vacation-page">
      <AopsSimpleHeader title="연차 관리" />

      <div className="my-hr-content-container">
        {/* 연차 현황 영역 */}
        <SectionHeader
          title="연차 현황"
          subtitle="전사 연차 현황을 확인하고 승인 및 연차 보상 여부를 관리할 수 있어요"
          buttonText=""
          onButtonClick={() => {}}
          iconType="arrow-right"
        />
        <VacationEmployeesListTable shouldRefresh={shouldRefresh} />
        <Flex
          gap={24}
          // align="center"
          justify="center"
          // style={{ marginTop: 24 }}
        >
          <VacationRequestListTable
            setOpenDetailModal={() => setOpenDetailModal(true)}
            setSelectedHistoryId={setSelectedHistoryId}
            setSelectedName={setSelectedName}
            setShouldRefresh={setShouldRefresh}
            shouldRefresh={shouldRefresh}
          />
          <VacationSettlementTable
            shouldRefresh={shouldRefresh}
            setShouldRefresh={setShouldRefresh}
          />
        </Flex>
      </div>

      <AopsVacationDetailModal
        open={openDetailModal}
        onClose={() => setOpenDetailModal(false)}
        title="연차 신청"
        onRefresh={() => {}}
        selectedName={selectedName}
        selectedHistoryId={selectedHistoryId}
        setShouldRefresh={setShouldRefresh}
        shouldRefresh={shouldRefresh}
      />
    </div>
  )
}

export default VacationAdminPage
